import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: 'app-new-default-page',
  templateUrl: './new-default-page.component.html',
  styleUrls: ['./new-default-page.component.scss']
})
export class NewDefaultPageComponent implements OnInit {

  selectedLang: string;

  constructor(
    private service: TranslateConfigService,
    private translate: TranslateService
  ) {
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }
  ngOnInit() {

  }

}
